import type { EmailTemplateSuggestion } from './types';

const CAMPAIGN_RECIPIENT_TEMPLATE_FIELDS = [
  'firstName',
  'lastName',
  'primaryPhoneNumber',
  'primaryEmail',
  'organisationName',
  'organisationAddress',
] as const;

export const addCampaignRecipientSuggestions = (
  suggestions: EmailTemplateSuggestion[],
): EmailTemplateSuggestion[] => [
  ...suggestions.filter(suggestion => !suggestion.id.startsWith('#recipient')),
  ...CAMPAIGN_RECIPIENT_TEMPLATE_FIELDS.map(field => {
    const placeholder = `#recipient.${field}`;

    return {
      id: placeholder,
      name: placeholder,
      value: placeholder,
    };
  }),
];
